/**
 * 常量
 */
export default {
    // 信达汇格
    CA_LOCKBRAND_XDHG: "201512281800580005",
    // 湖北CA
    CA_LOCKBRAND_HBCA: "201811291813450004",
    // 中金CA
    CA_LOCKBRAND_ZJCA: "201708031617450366",
    // 颐信科技
    CA_LOCKBRAND_ECCA: "201512281800350004",
}